import { type ReactNode, useRef } from 'react';

import useSizeMe from '~hooks/useSizeMe';

export const AspectRatioSizer = ({ children }: { children: ReactNode }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [size] = useSizeMe(ref);
  const maxSize = Math.min(size.width, size.height);
  return (
    <div className="min-w-full h-full" ref={ref}>
      <div className="icon-library--aspect-ratio-sizer relative w-full h-full flex justify-center items-center">
        <div style={{ maxWidth: maxSize, maxHeight: maxSize }} className={`w-full h-full relative`}>
          <div className={`absolute inset-0`}>{children}</div>
        </div>
      </div>
    </div>
  );
};
